import CoreModule from "modules/Core/core-modules/CoreModule";
import { SHELTER } from "./consts";
import LandingPage from "./components/screens/LandingPage";
import ContactPage from "./components/screens/ContactPage";
import PoliciesPage from "./components/screens/PoliciesPage";
import AccountDeletionPage from "./components/screens/AccountDeletionPage";
import PrivacyPolicyPage from "./components/screens/PrivacyPolicyPage";

export default new CoreModule({
  name: SHELTER,
  initialState: {},
  cells: {},
  routes: {
    "/homepage": LandingPage,
    "/contact": ContactPage,
    "/policies": PoliciesPage,
    "/delete-account": AccountDeletionPage,
    "/privacy": PrivacyPolicyPage,
  },
});
